import { useState, useCallback } from "react";
import { debounce } from "lodash";
import { checkOzonCredentials } from "../../ApiService";
import { FormikErrors } from "formik";

function useOzonCredentialsValidation(
	setFieldValue: (
		field: string,
		value: any,
		shouldValidate?: boolean
	) => Promise<void | FormikErrors<unknown>>,
	values: { clientId?: string; apiKey?: string }
) {
	const [isCredentialsValid, setCredentialsValid] = useState(false);

	const debouncedCheckCredentials = useCallback(
		debounce((clientId: string, apiKey: string) => {
			if (clientId && apiKey) {
				checkOzonCredentials({ clientId, apiKey })
					.then(({ valid }) => {
						setCredentialsValid(valid);
					})
					.catch((error) => {
						console.error("Error checking Ozon credentials:", error);
						setCredentialsValid(false);
					});
			} else {
				setCredentialsValid(false);
			}
		}, 500),
		[]
	);

	const handleClientIdChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const newClientId = e.target.value;
		setFieldValue("clientId", newClientId);
		debouncedCheckCredentials(newClientId, values.apiKey || "");
	};

	const handleApiKeyChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const newApiKey = e.target.value;
		setFieldValue("apiKey", newApiKey);
		debouncedCheckCredentials(values.clientId || "", newApiKey);
	};

	return {
		isCredentialsValid,
		handleClientIdChange,
		handleApiKeyChange,
	};
}

export default useOzonCredentialsValidation; 